import RouteConfig from './config/RouteConfig';
import EditVehicle from './directives/puw-edit-vehicle/PUWEditVehicle';
import PUWVinLookup from './directives/puw-vin-lookup/PUWVinLookup';
import defaultVehicleCoverages from './directives/PUWOfferingSelection/defaultQuoteView/defaultVehicleCoverages/defaultVehicleCoverages';
import defaultBaseCoverages from './directives/PUWOfferingSelection/defaultQuoteView/defaultBaseCoverages/defaultBaseCoverages';

import puwMobileCoverages from './directives/PUWOfferingSelection/mobileQuoteView/mobileCoverages/mobileCoverages';
import puwMobileCoveragesSummary from './directives/PUWOfferingSelection/mobileQuoteView/mobileCoveragesSummary/mobileCoveragesSummary';

import 'edge/quoteandbind/common/app';
import 'edge/policyjob/app';
import 'edge/platform/widgets/time/module';
import 'angularRouter';

export default angular.module('edge.quoteandbind.puw.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).filter('orderObjectBy', function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            /*eslint-disable */
            return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
            /* eslint-enable */
        });
        if (reverse) {
            filtered.reverse();
        }
        return filtered;
    };
}).directive('puwEditVehicle', EditVehicle).directive('qnbPuwVinLookup', function () {
    return new PUWVinLookup();
}).component('qnbDefaultPuwVehicleCoverages', defaultVehicleCoverages).component('qnbDefaultPuwBaseCoverages', defaultBaseCoverages).component('qnbPuwMobileCoverages', puwMobileCoverages).component('qnbPuwMobileSummary', puwMobileCoveragesSummary).constant('VinLookupEnabled', false);